import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { LazyLoadEvent, MenuItem, MessageService } from 'primeng/api';
import {AppDataService, ConfigService} from 'app/services';
import { Utils } from 'app/utils';
import { StylesStatus } from 'app/models/users/StylesStatus';
import {BetaFeature, DigitTypeEnum, FieldTypeEnum, LastActiveTypeModel} from 'app/models';
import * as moment from 'moment';
import {UserManagementService} from 'app/services/user-management.service';
import {EditTableConfig} from 'app/models/configs/edit-table-config';
import { ArchivingImagesService } from '../../../../services/archiving-images.service';
import {ColumnSelectorComponent} from 'app/column-selector/column-selector.component';
import { TableLazyLoadEvent } from 'primeng/table';

@Component({
    selector: 'user-managment-all-users',
    templateUrl: './user-managment-all-users.component.html',
    styleUrls: ['./user-managment-all-users.component.scss',
        '../../../../../styles/paginator.scss'],
    providers: [MessageService]
})
export class UserManagmentAllUsersComponent implements OnInit {

    @Input()
    public menuPermissionActive!: string;

    @ViewChild(ColumnSelectorComponent)
    public columnSelector!: ColumnSelectorComponent;

    uploadProgress: number = -1;
    fieldTypeEnum = FieldTypeEnum;
    users: Array<any> = [];
    lastActiveTypeList = LastActiveTypeModel.LastActiveTypeList;
    roles: Array<any> = [];
    arrayFilterLastActiveValues: any = LastActiveTypeModel.LastActiveTypeList;

    isArchiveFileDisabled: boolean = false;
    isImageManagementButtonDisabled: boolean = false;
    showDialogImageManagement: boolean = false;
    selectedUser: any = undefined;
    cols: any[] = [
        {
            disableSort: false,
            field: 'Id',
            fieldType: FieldTypeEnum.Inputs,
            header: 'User ID',
            model: 'Id',
            placeholder: 'Type here',
            showSortIcon: true,
            width: '10%',
            active: false
        },
        {
            field: 'UserName',
            header: 'User Name',
            width: '20%',
            disableSort: false,
            showSortIcon: true,
            model: 'UserName',
            fieldType: FieldTypeEnum.Inputs,
            placeholder: 'Type here',
            active: false
        },
        {
            disableSort: false,
            field: 'Email',
            fieldType: FieldTypeEnum.Inputs,
            header: 'Email',
            model: 'Email',
            placeholder: 'Type here',
            showSortIcon: true,
            width: '20%',
            active: false
        },
        {
            field: 'Role',
            header: 'Role',
            width: '20%',
            disableSort: false,
            showSortIcon: true,
            model: 'Role',
            fieldType: FieldTypeEnum.Dropdown,
            placeholder: 'Type here',
            options: this.roles,
            active: false
        },
        {
            disableSort: false,
            field: 'CreatedAt',
            fieldType: FieldTypeEnum.Calendar,
            header: 'Created',
            model: 'CreatedAt',
            placeholder: 'Type here',
            showSortIcon: true,
            width: '20%',
            active: false
        },
        {
            field: 'LastActive', header: 'Last Active', width: '20%', disableSort: false, showSortIcon: true,
            fieldType: FieldTypeEnum.Dropdown, model: 'lastActiveTypeObj',
            options: this.arrayFilterLastActiveValues, placeholder: 'Please Select', take: 'obj'
        }
    ];

    txnHeaderSearch: any = {
        Id: null,
        UserName: null,
        Email: null,
        Role: null,
        CreatedAt: null,
        lastActiveTypeObj: null,
    };

    // Grid settings
    rowsPerPage: number = Utils.getRowsPerPageCount();
    totalRecords: number = -1;
    first: number = 0;
    sortField: string | string[] = '';
    sortOrder: number = 1;

    filter: {
        searchName: string;
        startDateJoin: Date | undefined;
        endDateJoin: Date | undefined;
        digitType: DigitTypeEnum | undefined;
    } = { searchName: '', startDateJoin: undefined, endDateJoin: undefined, digitType: undefined };
    loading: boolean = true;
    selectedUsers: Array<any> = [];
    searchTimer: number = 0;
    displayModal: boolean = false;
    visibleUserFilter: boolean = false;
    displayModalSuspend: boolean = false;
    showEditFields: boolean = false;
    suspendUser: {
        userId: number | null;
        userName: string | null;
    } = { userId: null, userName: null };

    isVisibleUserInfo: boolean = false;
    hasAccessToImageManagement: boolean = false;
    tableName: string = EditTableConfig.USER_MANAGMENT_ALL_USERS;
    selectedColumns: any[] = [];
    public breadcrumbs: MenuItem[] = [{ icon: 'icon_settings' },{ label: 'Settings' },{ label: 'User Management' },{ label: 'All Users' }];

    constructor(
        private appData: AppDataService,
        private messageService: MessageService,
        private userManagementService: UserManagementService,
        public configService: ConfigService,
        private archivingImagesService: ArchivingImagesService,
    ) {
        this.hasAccessToImageManagement = this.appData.betaFeaturesIsExist([BetaFeature.ImageManagement]);
    }

    ngOnInit(): void {
        this.getRoles();
    }

    getRoles() {
        this.loading = true;
        const dto = {
            TimeZoneOffset: Utils.getTimezoneOffset()
        };
        this.userManagementService.getRoles(dto, this.messageService)
            .then(data => {
                if (!data.Success) {
                    this.loading = false;
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    return;
                }
                this.roles = data.Items;
                this.loading = false;
            })
            .catch(err => {
                this.loading = false;
                throw err;
            });
    }

    showPopupImageManagement() {
        this.showDialogImageManagement = true;
    }

    imageManagementCancel() {
        this.loading = false;
        this.showDialogImageManagement = false;
    }

    archiveFolders() {
        this.loading = true;
        this.isImageManagementButtonDisabled = true;
        this.archivingImagesService.archiveFolders({}, this.messageService)
            .then(blob => {
                this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Success' });
                const fileName = Utils.getFileNameFromResponse(blob);
                Utils.saveFileResponse(blob, fileName);
                this.loading = false;
                this.isImageManagementButtonDisabled = false;
            })
            .catch(err => {
                this.loading = false;
                this.isImageManagementButtonDisabled = false;
                throw err;
            });
    }

    downloadLatestArchive() {
        this.loading = true;
        this.isImageManagementButtonDisabled = true;
        this.archivingImagesService.downloadLatestArchive({}, this.messageService)
            .then(blob => {
                this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Archive downloaded successfully' });
                const fileName = Utils.getFileNameFromResponse(blob);
                Utils.saveFileResponse(blob, fileName);
                this.loading = false;
                this.isImageManagementButtonDisabled = false;
            })
            .catch(err => {
                this.loading = false;
                this.isImageManagementButtonDisabled = false;
                throw err;
            });
    }

    unpackLatestArchive() {
        this.loading = true;
        this.isImageManagementButtonDisabled = true;
        this.archivingImagesService.unpackLatestArchive({}, this.messageService)
            .then(data => {
                this.loading = false;
                this.isImageManagementButtonDisabled = false;
                if (!data.Success) {
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    return;
                }
            })
            .catch(err => {
                this.loading = false;
                this.isImageManagementButtonDisabled = false;
                throw err;
            });
    }

    scanAndPopulate() {
        this.loading = true;
        this.isImageManagementButtonDisabled = true;
        this.archivingImagesService.scanAndPopulate({}, this.messageService)
            .then(data => {
                this.loading = false;
                this.isImageManagementButtonDisabled = false;
                if (!data.Success) {
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    return;
                }
            })
            .catch(err => {
                this.loading = false;
                this.isImageManagementButtonDisabled = false;
                throw err;
            });
    }

    onSelectedColumnsChange(event: any[]) {
        if (event && event.length > 0) {
            this.selectedColumns = event;
        }
        else {
            this.selectedColumns = this.cols;
        }
    }

    handleLazyLoad(event: TableLazyLoadEvent): void {
        const skip = event.first ? event.first : 0;

        if (event.rows) {
            this.rowsPerPage = event.rows;
        }

        if (!event.sortField) {
            this.sortField = 'Id';
            this.sortOrder = -1; // Desc
        }
        else {
            this.sortField = event.sortField;
            this.sortOrder = event.sortOrder ? event.sortOrder : 1;
        }

        if (this.columnSelector) {
            this.columnSelector.loadTableSettings(this.tableName);
        }

        this.getUsers(skip);
    }

    getUsers(skip: number) {
        this.loading = true;
        const dto = {
            Id: (this.txnHeaderSearch.Id) ? this.txnHeaderSearch.Id : null,
            UserName: (this.txnHeaderSearch.UserName) ? this.txnHeaderSearch.UserName : null,
            Email: (this.txnHeaderSearch.Email) ? this.txnHeaderSearch.Email : null,
            RoleId: (this.txnHeaderSearch.Role) ? this.txnHeaderSearch.Role : null,
            CreatedAt: (!this.txnHeaderSearch.CreatedAt) ? null : moment(this.txnHeaderSearch.CreatedAt).format('YYYY-MM-DDTHH:mm:ss'),
            LastActiveType: (this.txnHeaderSearch.lastActiveTypeObj) ? this.txnHeaderSearch.lastActiveTypeObj.value : null,
            LastActiveAt: (this.txnHeaderSearch.lastActiveTypeObj && this.txnHeaderSearch.lastActiveTypeObj.dateTime) ?
                moment(this.txnHeaderSearch.lastActiveTypeObj.dateTime).format('YYYY-MM-DDTHH:mm:ss') : null,
            Skip: skip,
            Take: this.rowsPerPage,
            SortField: this.sortField,
            SortOrder: this.sortOrder,
            TimeZoneOffset: Utils.getTimezoneOffset()
        };

        this.userManagementService.getUsers(dto, this.messageService)
            .then(data => {
                if (!data.Success) {
                    this.loading = false;
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    return;
                }
                this.first = skip;
                this.totalRecords = data.TotalRecords;
                this.users = data.Items;
                this.users.forEach(item => {
                    item.CreatedAt = moment(item.CreatedAt).format('MM/DD/YY');
                });
                this.loading = false;
            })
            .catch(err => {
                this.loading = false;
                throw err;
            });
    }

    onSelectionChange(value = []) {
        this.selectedUsers = value;
    }

    handleFilterChange(model: string, event: any): void {
        if (this.searchTimer) {
            window.clearTimeout(this.searchTimer);
        }

        this.searchTimer = window.setTimeout(() => {
            this.getUsers(0);
            this.searchTimer = 0;
        }, 1500);
    }

    onChangeHeaderFilterDropDown(model: string, event: any) {
        if (this.searchTimer) {
            window.clearTimeout(this.searchTimer);
        }

        this.searchTimer = window.setTimeout(() => {
            this.getUsers(0);
            this.searchTimer = 0;
        }, 1000);
    }

    changedDisplayModalSuspendEmit(value: any) {
        this.displayModalSuspend = value;
    }

    handlePopupLinkClick(user: any): void {
        this.selectedUser = user;
        this.isVisibleUserInfo = this.selectedUser !== undefined;
    }

    onAddUserClick(): void {
        this.isVisibleUserInfo = true;
        this.selectedUser = {
            FirstName: '',
            LastName: '',
            Email: '',
            RoleId: null,
        };
    }

    changedVisibleUserEmit(value: boolean) {
        this.isVisibleUserInfo = false;
        if (value) {
            this.getUsers(0);
        }
    }

    getStatusStyles(status: string): StylesStatus {
        let backgroundColor: string;
        let textColor: string;

        switch (status) {
            case 'Active':
                backgroundColor = '#E7F7EF';
                textColor = '#1CBA70';
                break;
            case 'Non active':
            case 'Offline':
                backgroundColor = '#FDEBEA';
                textColor = '#EB4236';
                break;
            default:
                backgroundColor = '';
                textColor = '';
        }

        return {
            backgroundColor,
            color: textColor
        };
    }
    getLastActiveStyles(lastActive: string): string {
        let textColor: string = '';

        if (lastActive !== 'Never') {
            const today = new Date();
            const lastActiveDate = new Date(lastActive);
            const monthsDiff = (today.getFullYear() - lastActiveDate.getFullYear()) * 12 +
                (today.getMonth() - lastActiveDate.getMonth());
            if (monthsDiff > 3) {
                textColor = '#FFB100';
            }
        } else {
            textColor = '#EB4236';
        }

        return textColor;
    }

    handleHeaderFilterChange(event: any) {
        if (this.searchTimer) {
            window.clearTimeout(this.searchTimer);
        }

        this.searchTimer = window.setTimeout(() => {
            this.getUsers(0);
            this.searchTimer = 0;
        }, 1500);
    }

    handleInputClick(id: string): void {
        if (this.isArchiveFileDisabled) {
            return;
        }
        this.isArchiveFileDisabled = true;
        document.getElementById(id)?.click();
    }

    handleArchiveFile(event: Event) {
        this.loading = true;
        const target = event.target as HTMLInputElement;
        const file: File | null = target.files ? target.files[0] : null;

        if (!file) {
            this.isArchiveFileDisabled = false;
            return;
        }

        const chunkSize = 10 * 1024 * 1024; // 10MB
        const totalChunks = Math.ceil(file.size / chunkSize);
        const fileId = this.generateFileId(file.name); // Unique upload ID
        let currentChunk = 0;

        const uploadChunk = () => {
            if (currentChunk >= totalChunks) {
                this.finalizeUpload(fileId, file.name, totalChunks);
                return;
            }

            const start = currentChunk * chunkSize;
            const end = Math.min(start + chunkSize, file.size);
            const chunk = file.slice(start, end);

            const formData = new FormData();
            formData.append('file', chunk);
            formData.append('fileName', file.name);
            formData.append('chunkIndex', currentChunk.toString());
            formData.append('totalChunks', totalChunks.toString());

            this.archivingImagesService.uploadArchiveChunk(formData, this.messageService)
                .then(() => {
                    currentChunk++;
                    const chunkProgress = (currentChunk / totalChunks) * 80;
                    this.uploadProgress = Math.round(chunkProgress);
                    uploadChunk();
                })
                .catch(err => {
                    this.loading = false;
                    this.isArchiveFileDisabled = false;
                    this.messageService.add({ severity: 'error', summary: 'Upload Error', detail: err });
                    this.uploadProgress = -1;
                });
        };

        uploadChunk();
    }

    finalizeUpload(fileId: string, fileName: string, totalChunks: number) {
        const request: any = {
            fileId,
            fileName,
            totalChunks
        };
        this.archivingImagesService.finalizeUpload(request, this.messageService)
            .then(() => {
                this.loading = false;
                this.isArchiveFileDisabled = false;
                this.messageService.add({ severity: 'success', summary: 'Upload Complete', detail: 'File uploaded successfully!' });
                this.uploadProgress = 100;
            })
            .catch(err => {
                this.loading = false;
                this.isArchiveFileDisabled = false;
                this.messageService.add({ severity: 'error', summary: 'Finalize Error', detail: err });
                this.uploadProgress = -1;
            });
    }

    generateFileId(fileName: string): string {
        const timestamp = Date.now();
        const randomValue = Math.random().toString(36).slice(2, 11);
        const fileNameHash = this.hashString(fileName);
        return `${fileNameHash}-${timestamp}-${randomValue}`;
    }

    hashString(str: string): string {
        let hash = 0;
        const prime = 31;
        for (let i = 0; i < str.length; i++) {
            hash = (hash * prime + str.charCodeAt(i)) % 1_000_000_007;
        }
        return hash.toString(36);
    }
}
